import { EndorsementType } from './domain.models';

export interface EndorsementField {
  key: string;
  label: string;
  type: 'text' | 'date' | 'select';
  options?: string[];
}

export interface EndorsementTypeDef {
  type: EndorsementType;
  /** Affects money, coverages or items, so it can never be registered as a free endorsement. */
  monetary: boolean;
  fields: EndorsementField[];
}

/** Illustrative per-type data of the change (spec P-50 step 2). `risk-change` on autos uses the vehicle catalog instead. */
export const ENDORSEMENT_TYPES: EndorsementTypeDef[] = [
  { type: 'risk-change', monetary: true, fields: [{ key: 'subject', label: 'Nuevo riesgo (descripción)', type: 'text' }] },
  { type: 'item-add', monetary: true, fields: [{ key: 'item', label: 'Ítem a agregar', type: 'text' }] },
  { type: 'item-remove', monetary: true, fields: [{ key: 'item', label: 'Ítem a dar de baja', type: 'text' }] },
  { type: 'coverage-change', monetary: true, fields: [{ key: 'plan', label: 'Nuevo plan', type: 'select' }] },
  {
    type: 'data-change', monetary: false,
    fields: [{ key: 'field', label: 'Dato a cambiar', type: 'text' }, { key: 'value', label: 'Nuevo valor', type: 'text' }],
  },
  { type: 'term-extension', monetary: true, fields: [{ key: 'endDate', label: 'Nueva fecha de fin de vigencia', type: 'date' }] },
  {
    type: 'assignment', monetary: false,
    fields: [{ key: 'beneficiary', label: 'Beneficiario o acreedor prendario', type: 'text' }],
  },
  { type: 'cancellation', monetary: true, fields: [{ key: 'reason', label: 'Motivo de la anulación', type: 'text' }] },
  { type: 'termination', monetary: true, fields: [{ key: 'reason', label: 'Motivo de la rescisión', type: 'text' }] },
  { type: 'free', monetary: false, fields: [] },
];

export function endorsementDef(type: EndorsementType): EndorsementTypeDef {
  return ENDORSEMENT_TYPES.find(t => t.type === type)!;
}

export const ENDING_TYPES: EndorsementType[] = ['cancellation', 'termination'];
